// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// this tracks required groups for various features within the UI
// the intention is to keep these all in a single space.
// if there's a one-off role check like "hide Filing Status tab for Internal_Users"
// then you can keep that in its own space.
// this is just for common group checks which are repeated throughout the application.

// NOTE - we are no longer tracking the Data_Product role in the UI.

export const ROLES_PATH_DATABASE = ['Path_Database']

export const ROLES_PROJECT_TRACKER = ['Frequency_Coordination', 'Internal_Users']

export const ROLES_PROTECTION = ['Frequency_Protection']

export const ROLES_PRICING_MANAGEMENT = ['Internal_Admin']

export const ROLES_SUAS = ['SUAS'] // RF Drone Services role
